import {
  Avatar,
  Badge,
  Card,
  Divider,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  styled,
  Typography,
} from '@mui/material';

import React from 'react';
import PropTypes from 'prop-types';
import getQualifiedImageUrl from '../../utils/imageUrlProcessor';
import FollowUserButton from '../Buttons/FollowUserButton';
import StyledBoldTypography from '../Styled/StyledBoldTypography';
import useStore from '../../stores/store';
import { LikeIcons } from '../../constants/likeDetails.constant';
import { getAvatarText } from '../../utils/stringHelpers';
import { ProfileTypes } from '../../constants/profileType.constant';

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.innerGray}`,
  backgroundColor: theme.palette.primary.lightbg,
  padding: 2,
}));

function PostReactionCard(props) {
  const { user } = props;
  const currentUser = useStore((state) => state.user.profile);
  const canFollow =
    user.id !== currentUser.id && user.companyId === currentUser.activeCommunityId;
  const isNPAdmin = useStore((state) => state.user.isNonProfitAdmin);
  const jobTitle = isNPAdmin
    ? `${user.designation} ${user?.orgDetails?.name ? `- ${user?.orgDetails?.name}` : ''}`
    : user.designation;

  const avatar =
    user.as === ProfileTypes.Organization
      ? user?.orgDetails?.logoUrl || 'avatar-logo'
      : user.avatar;
  const name =
    user.as === ProfileTypes.Organization
      ? user?.orgDetails?.name || ''
      : `${user.first_name} ${user.last_name}`;

  return (
    <ListItem
      alignItems="flex-start"
      secondaryAction={canFollow && <FollowUserButton user={user} />}>
      <ListItemAvatar>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={
            <SmallAvatar alt="smallicon" src={LikeIcons[user.likeType]} />
          }>
          <Avatar alt="user avatar" src={getQualifiedImageUrl(avatar)}>
            {getAvatarText(name)}
          </Avatar>
        </Badge>
      </ListItemAvatar>
      <ListItemText
        primary={
          <StyledBoldTypography variant="subtitle1">
            {name}
          </StyledBoldTypography>
        }
        secondary={
          <Typography variant="body2" color="textSecondary">
            {jobTitle}
          </Typography>
        }
      />
    </ListItem>
  );
}

export default PostReactionCard;

PostReactionCard.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    likeType: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    designation: PropTypes.string.isRequired,
    orgDetails: PropTypes.shape({
      name: PropTypes.string.isRequired,
      logoUrl: PropTypes.string.isRequired,
    }),
    as: PropTypes.string,
    companyId: PropTypes.number.isRequired,
  }).isRequired,
};
